function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import IconX from '~icons/bx/x';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "opde7s",
  styles: "color:inherit"
} : {
  name: "19gl64f-ButtonClose",
  styles: "color:inherit;label:ButtonClose;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "18mxbui",
  styles: "width:1em;height:1em"
} : {
  name: "14fqnx9-ButtonClose",
  styles: "width:1em;height:1em;label:ButtonClose;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export function ButtonClose(props) {
  return <div css={_ref} {...props}>
			<IconX css={_ref2} />
		</div>;
}